import $ from "jquery";

$(".newsletter__close").click(function () {
  $(".newsletter").hide();
});
$(".newsletter__open").click(function () {
  $(".newsletter").show();
});
